import SocialMediaSection from './social-media/SocialMediaSection';
import VisualIdentitySection from './visual-identity/VisualIdentitySection';

export default function ResourcesSection() {
  return (
    <div className="space-y-8">
      <VisualIdentitySection />
      <SocialMediaSection />
    </div>
  );
}
